var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.userData.id
    ? _c(
        "div",
        { staticClass: "homeHeader" },
        [
          _vm.userData.isSys == 0
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.getClick },
                },
                [_vm._v("考生审核")]
              )
            : _vm._e(),
          _c("div", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v(_vm._s(_vm.userData.orgName || "") + " "),
            _vm.userData.orgName ? _c("span", [_vm._v("-")]) : _vm._e(),
            _vm._v(" " + _vm._s(_vm.userData.name || "")),
          ]),
          _c("el-avatar", {
            attrs: { size: "small", src: _vm.circleUrl },
            nativeOn: {
              click: function ($event) {
                return _vm.getOpenUserDia.apply(null, arguments)
              },
            },
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "用户信息",
                visible: _vm.userDialogVisible,
                center: "",
                "show-close": "",
                "custom-class": "usertimeDialog",
                width: "650px",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.userDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "mainContent" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      class: { "rule-none-img": !_vm.newUserdata.photoUrl },
                      attrs: {
                        model: _vm.newUserdata,
                        "label-width": "80px",
                        disabled: "",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: "",
                              onfocus: "this.removeAttribute('readonly');",
                            },
                            model: {
                              value: _vm.newUserdata.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newUserdata,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newUserdata.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.newUserdata.pinyin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "姓名拼音" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                },
                                model: {
                                  value: _vm.newUserdata.pinyin,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newUserdata,
                                      "pinyin",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "newUserdata.pinyin",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "身份证号" } },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: "",
                              onfocus: "this.removeAttribute('readonly');",
                            },
                            model: {
                              value: _vm.newUserdata.idCard,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newUserdata,
                                  "idCard",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newUserdata.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号码" } },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: "",
                              onfocus: "this.removeAttribute('readonly');",
                            },
                            model: {
                              value: _vm.newUserdata.mobile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newUserdata,
                                  "mobile",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newUserdata.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "专业" } },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: "",
                              onfocus: "this.removeAttribute('readonly');",
                            },
                            model: {
                              value: _vm.newUserdata.major,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newUserdata,
                                  "major",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newUserdata.major",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "就读院校" } },
                        [
                          _c("el-input", {
                            attrs: {
                              readonly: "",
                              onfocus: "this.removeAttribute('readonly');",
                            },
                            model: {
                              value: _vm.newUserdata.orgName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.newUserdata,
                                  "orgName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "newUserdata.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.newUserdata.photoUrl
                    ? _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: _vm.actionUrl,
                                "show-file-list": false,
                                "on-success": _vm.handleAvatarSuccess,
                                "before-upload": _vm.beforeAvatarUpload,
                              },
                            },
                            [
                              _c("img", {
                                ref: "uploadImg",
                                staticClass: "avatar",
                                attrs: { src: _vm.newUserdata.photoUrl },
                              }),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "hover-el",
                              staticStyle: {
                                "margin-left": "30px",
                                color: "black",
                                "text-decoration": "underline",
                              },
                              attrs: { type: "text" },
                              on: {
                                click: function () {
                                  return _vm.$refs.uploadImg.click()
                                },
                              },
                            },
                            [_vm._v(" 重新上传 ")]
                          ),
                          _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "widget rich_text undefined hleft vtop ",
                                      staticStyle: {
                                        width: "166px",
                                        "font-size": "14px",
                                        "text-align": "left",
                                        "font-weight": "normal",
                                        "font-style": "normal",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "rich-text" }, [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [
                                                _vm._v(
                                                  "学生照片标准请参照下列要求准备"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [_vm._v(" 1.照片格式：jpg、png")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [_vm._v(" 2.照片大小：5M 以内")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [_vm._v(" 3.照片像素：295*413")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [
                                                _vm._v(
                                                  " 4.照片尺寸：2.7cmx3.8cm (宽*长)"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [_vm._v(" 5.照片底色:红色")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "line-height": "0",
                                              "margin-bottom": "5px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "--mb--rich-text",
                                                staticStyle: {
                                                  "font-family":
                                                    "SourceHanSansSC",
                                                  "font-weight": "400",
                                                  "font-size": "10px",
                                                  color: "rgba(228,228,228,1)",
                                                  "font-style": "normal",
                                                  "letter-spacing": "0px",
                                                  "line-height": "8px",
                                                  "text-decoration": "none",
                                                },
                                                attrs: { "data-boldtype": "0" },
                                              },
                                              [_c("br")]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c("span", {
                              staticClass: "el-icon-info",
                              staticStyle: { "margin-left": "5px" },
                            }),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "info" },
                      on: {
                        click: function () {
                          _vm.userDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger" },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v("退出登录")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }